export const ScriptPages = {
  home: "homepage",
  outcomes: "outcomes",
};
